/**
 * Achievements UI module.
 *
 * Internal barrel for the achievements presentation layer. The public import
 * path for all consumers remains `components/progress/AchievementsSection.tsx`,
 * which re-exports everything here plus the mascot-domain SSOT values/types.
 *
 * Mirrors the `mascot/avatar/` split (MASCOT_SSOT_ARCHITECTURE_AUDIT_2026 §4.2):
 * the section file is a thin barrel; behaviour lives in focused modules here.
 */

export { useAchievementShimmer } from './useAchievementShimmer';
export { SparkleParticles, GoldenShimmer, LegendaryGlow } from './effects';
export { RarityDjayWrapper } from './RarityDjayWrapper';
export { CompactAchievementCard } from './CompactAchievementCard';
export { AchievementCard } from './AchievementCard';
export { CollectibleAchievementCard } from './CollectibleAchievementCard';
export { AchievementsSection } from './AchievementsSection';
export type { AchievementCardProps } from './types';